import { IApplicationState } from '../../types/redux';

export const getSubtitle = (state: IApplicationState) => {
  return state.offersData.seo?.subtitle;
};
